export default __webpack_public_path__ + "static/3-8b6706c6023d9d3578cd2568ee19b97d.png";